import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAtom } from 'jotai';
import { currentUserAtom, authLoadedAtom } from '../auth/AuthAtoms';

const AdminRoute = () => {
    const [currentUser] = useAtom(currentUserAtom);
    const [authLoaded] = useAtom(authLoadedAtom);
    const isAuthenticated = !!localStorage.getItem('accessToken');

    if (!authLoaded) return null;

    return isAuthenticated && currentUser?.isAdmin ? <Outlet /> : <Navigate to="/" />;
};

export default AdminRoute;
